<app-laasy-modal #laasyModal *ngIf="ssoCognitoEmailPasswordSignup.showModal" [modalTitle]="ssoCognitoEmailPasswordSignup.heading" [modalMessage]="ssoCognitoEmailPasswordSignup.description" [confirmButtonText]="'Continue'" (confirmButtonClicked)="SSORedirectWithUserData()"></app-laasy-modal>
<div *ngIf="signupPageCount === SignupTenantPageCount?.getting_started" class="getting-started-page-container">
  <app-common-welcome
    [continueText]="'Get Started'"
    (next)="getStarted()">
    <div *ngFor="let x of SSO_val" class="button">
      <ng-container [ngTemplateOutlet]="SSObutton" [ngTemplateOutletContext]="{ ssoVal: x }">
      </ng-container>
    </div>
    <app-toast></app-toast>
  </app-common-welcome>
  <div class="navigate-to-login">
    <p>
      Already have an account? <span class="navigate-link" (click)="navigate('login')">Log In</span>
    </p>
  </div>
</div>

<!-- subtenant selection -->
<div *ngIf="signupPageCount === SignupTenantPageCount?.subtenant">
  <app-subtenant-selection (subtenantClick)="selectedSubtenant($event)"></app-subtenant-selection>
</div>

<!-- survey -->
<div *ngIf="signupPageCount === SignupTenantPageCount?.survey">
  <app-survey [userProfile]="userProfile"></app-survey>
</div>

<!-- email signup -->
<ng-container *ngIf="isForm()">
  <app-progress-bar [noOfView]="noOfView" [signUpPageCount]="signupPageCount"></app-progress-bar>
  <app-auth-connect-header></app-auth-connect-header>
  <div class="form-body">
    <form #authForm="ngForm">
      <app-auth-code *ngIf="signupPageCount === SignupTenantPageCount.auth_code" [userProfile]="userProfile" ></app-auth-code>
      <form #emailPassAuthForm="ngForm" *ngIf="signupPageCount === SignupTenantPageCount.create_account">
        <div class="email fields">
          <app-input
            [type]="'email'"
            name="email"
            [formGroup]="emailPassAuthForm"
            [(ngModel)]="userProfile.email"
            label="Email *"
            [placeholder]="'Email'"
            required
            pattern="^[\w.!#$%&'*+/=?^_`{|}~-]+@[\w](?:[\w-]{0,61}[\w])?(?:\.[\w](?:[\w-]{0,61}[\w])?)*$"
            [readOnly]="readOnlyEmail"
            #email="ngModel"
          ></app-input>
        </div>
        <app-marketing-info
          [userProfile]="userProfile"
          [elementName]="elementName"
        ></app-marketing-info>
        <app-update-password [authForm]="emailPassAuthForm" [userProfile]="userProfile"></app-update-password>
        <app-form-navigation-buttons [form]="emailPassAuthForm" [userProfile]="userProfile" ></app-form-navigation-buttons>
      </form>
      <app-personal-info
        *ngIf="signupPageCount === SignupTenantPageCount.personal_info"
        [userProfile]="userProfile"
        [page]="page"
      ></app-personal-info>
      <app-contact-no
        *ngIf="signupPageCount === SignupTenantPageCount.contact_detail"
        [page]="page"
        [userProfile]="userProfile"
      ></app-contact-no>
      <app-verify-otp *ngIf="signupPageCount===SignupTenantPageCount?.email_OTP"
        [userProfile]="userProfile"
        ></app-verify-otp>
    </form>
  </div>
</ng-container>
